export function convertDate(date) {
    return date
        ? new Date(typeof date === 'string' ? date.replace(/\+([0-9]{2}):?([0-9]{2})/g, '+$1:$2') : date)
        : undefined;
}
